import React from 'react';

import styled from 'styled-components';

import ShopNotesAttachment from './ShopNotesAttachment';
import ShopNotesText from './ShopNotesText';
import { ShopNotesType } from '../types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

interface Props {
  shopNote: ShopNotesType;
}

const ShopNotesItem = ({ shopNote }: Props) => {
  const fileUrl = shopNote?.attachment_url || shopNote?.file_url;

  return (
    <Container>
      <ShopNotesText text={shopNote?.request_notes} />
      <ShopNotesAttachment fileUrl={fileUrl} />
    </Container>
  );
};

export default ShopNotesItem;
